<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <v-icon
          v-if="$vuetify.breakpoint.mdAndDown"
          class="me-3 mt-2"
          @click="toggleVerticalNavMenuActive"
        >
          {{ icons.mdiMenu }}
        </v-icon>
        <!--Search Bar -->
        <SearchBar />

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} {{ appName }}<span class="d-none d-md-inline"></span></span>
        <!-- <div class="align-center d-none d-md-flex">
          <span>Hand-crafted &amp; Made with</span>
          <v-icon
            color="error"
            class="ms-2"
          >
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div> -->
      </div>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import { getVuetify } from '@core/utils'
import { mdiHeartOutline, mdiMenu } from '@mdi/js'
import {
  computed, ref, watch, getCurrentInstance,
} from '@vue/composition-api'

// App Bar Components
import themeConfig from '@themeConfig'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'

// Search Data
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import appBarSearchData from '@/assets/app-bar-search-data'
import navigationModule from '@/navigation/vertical'
import SearchBar from './_components/SearchBar.vue'

// import { app } from '../../../../../themeConfig'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components

    AppBarUserMenu,
    SearchBar,
  },
  mounted() {
    // Inicia o monitoramento de alertas quando o layout é montado
    this.$startAlertMonitoring()
  },
  beforeDestroy() {
    // Para o monitoramento quando o layout é destruído
    this.$stopAlertMonitoring()
  },
  setup() {
    const $vuetify = getVuetify()
    const { proxy } = getCurrentInstance()
    const store = proxy?.$store

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    // NOTE: Update search function according to your usage
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    const getStoredPermissions = () => {
      try {
        const stored = localStorage.getItem('permissions')
        if (!stored) return null

        return JSON.parse(stored)
      } catch (error) {
        return null
      }
    }

    const navMenuFactory = typeof navigationModule === 'function' ? navigationModule : null
    const staticNavMenu = Array.isArray(navigationModule) ? navigationModule : []

    const navMenuItems = computed(() => {
      if (navMenuFactory) {
        const permissions = store?.getters['login/getPermissions']
        const safePermissions = Array.isArray(permissions) ? permissions : getStoredPermissions()

        return navMenuFactory(safePermissions)
      }

      return staticNavMenu
    })

    return {
      navMenuItems,
      handleShallShowFullSearchUpdate,
      appName: themeConfig.app.name,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,

      icons: {
        mdiMenu,
        mdiHeartOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
